import DOMPurify from "dompurify";

// Client-side sanitization of document HTML, belt-and-braces on top of the
// server's nh3 allowlist (the spec's stored-XSS boundary: canonical HTML is
// only ever *rendered* sanitized, even though it was sanitized at ingest).
//
// Render policy: viewing a document must fire NO remote requests. `img` is
// deliberately stripped AT RENDER even though the server allowlist stores
// it — a remote `src` pings an arbitrary host when the document is viewed
// (tracking-pixel / IP-leak vector). The archived content keeps its images,
// so a later proxy or per-document toggle can re-enable display losslessly.
// The other media tags/attrs below aren't in the server allowlist today,
// but this layer exists for the day that layer fails or grows — forbid
// every remote-fetch vector, not just the one currently reachable
// (L4 review finding). Pinned by sanitizeHtml.test.js, not just by comment.
const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    "img",
    "audio",
    "video",
    "source",
    "picture",
    "track",
    "style",
    "form",
    "input",
    "button",
  ],
  FORBID_ATTR: ["style", "background", "poster", "srcset"],
  // The server already forces rel=noopener; keep links non-navigating here
  // too if DOMPurify's defaults ever change underneath us.
  ADD_ATTR: ["rel"],
};

/** Sanitize canonical document HTML for rendering. */
export function sanitizeDocumentHtml(html) {
  return DOMPurify.sanitize(html || "", SANITIZE_OPTIONS);
}

// Search snippets are server-escaped plain text where the ONLY markup is the
// <b> match markers the backend itself inserted — so allow exactly that.
const SNIPPET_OPTIONS = { ALLOWED_TAGS: ["b"], ALLOWED_ATTR: [] };

/** Sanitize a search-result snippet (plain text + <b> highlights only). */
export function sanitizeSnippetHtml(html) {
  return DOMPurify.sanitize(html || "", SNIPPET_OPTIONS);
}
